import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CHECKOUT_MEGAPACK, CHECKOUT_MEGAPACK_KIT } from '../data/content';
type FinalPlan = {
  emoji: string;
  name: string;
  includes: string;
  oldPrice: string;
  price: string;
  cta: string;
  href: string;
  featured: boolean;
};
const finalPlans: FinalPlan[] = [{
  emoji: '📘',
  name: 'MegaPack Caligrafía y Lectoescritura',
  includes: '6 Tomos + 6 Bonos · Todos los niveles',
  oldPrice: '$51.000',
  price: '$19.990 ARS',
  cta: '→ Quiero mi MegaPack',
  href: CHECKOUT_MEGAPACK,
  featured: false
}, {
  emoji: '🏆',
  name: 'MegaPack + Kit Inclusión',
  includes: '6 Tomos + 6 Bonos + Kit Inclusión completo',
  oldPrice: '$69.000',
  price: '$27.990 ARS',
  cta: '→ Quiero el MegaPack + Kit Inclusión',
  href: CHECKOUT_MEGAPACK_KIT,
  featured: true
}];
const badges: {
  icon: React.ReactNode;
  label: string;
}[] = [{
  icon: <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-74" data-mp="n6e2nf8ng5t7" />,
  label: 'Pago 100% seguro'
}, {
  icon: <ZapIcon className="h-4 w-4" aria-hidden="true" data-id="element-75" data-mp="s45sm3pqhhur" />,
  label: 'Acceso en 5 minutos'
}, {
  icon: <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-76" data-mp="x41xe5699dbd" />,
  label: 'Garantía 7 días'
}, {
  icon: <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-77" data-mp="122lik3d0yl2o" />,
  label: 'Mercado Pago · Tarjeta · Transferencia'
}];
export function FinalCta() {
  return <section id="comprar" aria-labelledby="cierre-titulo" className="w-full bg-navy-deep py-14 text-white sm:py-20" data-id="element-78" data-mp="162dyj14qzti2">
      <div className="mx-auto max-w-5xl px-5" data-id="element-79" data-mp="1ftqf2wl3ix8s">
        <div className="mx-auto max-w-2xl text-center" data-id="element-80" data-mp="1fv1s7n0flhck">
          <h2 id="cierre-titulo" className="font-display text-3xl font-extrabold leading-tight text-balance sm:text-4xl lg:text-5xl" data-id="element-81" data-mp="1ktmioupvsmnt">
            El próximo domingo puede ser diferente.
          </h2>

          <div className="mt-6 space-y-4 text-left text-base leading-relaxed text-celeste-light sm:text-lg" data-id="element-82" data-mp="1tukrdqb9licq">
            <p data-id="element-83" data-mp="3qsku2et1hypn">
              No el domingo en que por fin encuentres el material perfecto online.{' '}
              <strong className="font-extrabold text-white" data-id="element-84" data-mp="3lthpswkvvwiq">Este domingo.</strong>
            </p>
            <p data-id="element-85" data-mp="3jplknr873t9">
              Descargás. Imprimís. Y el lunes entrás al aula — o te sentás con tu hijo/a —
              sabiendo exactamente qué hacer, por qué lo hacés y qué viene después.
            </p>
            <p className="font-bold text-white" data-id="element-86" data-mp="dhlsf3d4rclk">
              Eso es lo que +1.200 familias y docentes argentinos ya tienen. Ahora te toca
              a vos.
            </p>
          </div>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-87" data-mp="me4hg4i8qgcv">
          {finalPlans.map(plan => <article key={plan.name} className={`relative flex flex-col rounded-3xl border-2 p-6 sm:p-7 ${plan.featured ? 'border-gold bg-white/10 shadow-pop' : 'border-white/20 bg-white/5'}`} data-id="element-88" data-mp="id117gwa6ib4">
              {plan.featured && <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-gold px-4 py-1 font-display text-xs font-extrabold uppercase tracking-widest text-navy-deep" data-id="element-89" data-mp="2e3vrptxkgvzl">
                  ⭐ Más elegido
                </span>}

              <h3 className="mt-2 font-display text-xl font-extrabold leading-tight" data-id="element-90" data-mp="259qson8a4e8z">
                <span aria-hidden="true" data-id="element-91" data-mp="1qcricrm1m7at">{plan.emoji} </span>
                {plan.name}
              </h3>
              <p className="mt-2 text-sm font-bold text-celeste-light" data-id="element-92" data-mp="1vep8m5sv22d9">{plan.includes}</p>

              <div className="mt-auto pt-6" data-id="element-93" data-mp="1hf7dz9svvuvz">
                <p className="text-base font-bold text-white/50 line-through" data-id="element-94" data-mp="1mcfvd867juw6">
                  {plan.oldPrice}
                </p>
                <p className="font-display text-4xl font-extrabold leading-none text-gold sm:text-5xl" data-id="element-95" data-mp="3bsp0qulgsnpy">
                  {plan.price}
                </p>
                <CtaButton href={plan.href} variant={plan.featured ? 'primary' : 'secondary'} className="mt-6 w-full text-center" data-id="element-96" data-mp="1goh9trvygkih">
                  {plan.cta}
                </CtaButton>
              </div>
            </article>)}
        </div>

        <ul className="mt-9 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-white/75 sm:text-sm" data-id="element-97" data-mp="12phmqoo3cdof">
          {badges.map(badge => <li key={badge.label} className="inline-flex items-center gap-1.5" data-id="element-98" data-mp="sywt7fn9xzcd">
              <span className="text-celeste" data-id="element-99" data-mp="swtsa0kl2lsv">{badge.icon}</span>
              {badge.label}
            </li>)}
        </ul>
      </div>
    </section>;
}